import { useNavigate } from 'react-router-dom';

const NAVY   = '#0a2540';
const ORANGE = '#F37428';

export default function AdminLoggedOut() {
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const reason = params.get('reason');

  let message = 'Your session expired due to inactivity. Please sign in again.';
  if (reason === 'expired') message = 'Your session has expired.';
  else if (reason === 'inactivity') message = 'Your session expired due to inactivity. Please sign in again.';

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.logoRow}>
          <img
            src="https://www.masterfileai.com/hubfs/logo3.png"
            alt="MasterFileAI"
            style={{ height: 34, maxWidth: 180, objectFit: 'contain' }}
            onError={e => { e.target.style.display = 'none'; e.target.nextElementSibling.style.display = 'block'; }}
          />
          <span style={{ display: 'none', color: NAVY, fontWeight: 700, fontSize: 20 }}>MasterFileAI</span>
        </div>

        <div style={s.adminBadge}>ADMIN CONSOLE</div>

        <div style={s.iconWrap}>
          <span style={s.icon}>🔒</span>
        </div>

        <h1 style={s.heading}>You've been signed out</h1>
        <p style={s.message}>{message}</p>

        <button style={s.btn} onClick={() => navigate('/admin/login')}>
          Sign in to Admin →
        </button>
      </div>
    </div>
  );
}

const s = {
  page:       { minHeight: '100vh', background: NAVY, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px 16px', fontFamily: "'Inter', system-ui, sans-serif" },
  card:       { background: '#fff', borderRadius: 16, padding: '44px 40px', width: '100%', maxWidth: 400, boxShadow: '0 32px 80px rgba(0,0,0,0.4)', textAlign: 'center' },
  logoRow:    { display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 24 },
  adminBadge: { background: 'rgba(10,37,64,0.06)', border: '1px solid rgba(10,37,64,0.15)', borderRadius: 6, color: NAVY, fontSize: 10, fontWeight: 700, letterSpacing: '0.12em', padding: '3px 10px', display: 'inline-block', marginBottom: 20 },
  iconWrap:   { marginBottom: 12 },
  icon:       { fontSize: 40 },
  heading:    { color: NAVY, fontSize: 22, fontWeight: 700, margin: '0 0 12px', letterSpacing: '-0.3px' },
  message:    { color: '#64748b', fontSize: 14, lineHeight: 1.6, margin: '0 0 28px' },
  btn:        { background: ORANGE, border: 'none', borderRadius: 8, color: '#fff', cursor: 'pointer', fontSize: 15, fontWeight: 600, padding: '13px 24px', width: '100%' },
};
